export default __webpack_public_path__ + "static/media/TO.d229c4c3.svg";